import PageContainer from "../../componets/containers/PageContainer";
import {useEffect, useState} from "react";
import statesApi from "../../services/statesApi";
import typePropertyApi from "../../services/typePropertyApi";
import propertyApi from "../../services/propertyApi";
import InputSelect from "../../componets/inputs/inputSelect";
import {FaSearch} from "react-icons/fa";
import cityApi from "../../services/cityApi";
import {QueryParams} from "../../types";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Str from "../../helpers/Str";
import { FaArrowDown } from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import { BiArea } from "react-icons/bi";
import { BsHouseCheckFill } from "react-icons/bs";
export default function HomeProperties() {
    const [stateSearch, setStateSearch] = useState({
        state_id: '',
        city_id: '',
        tipo_id: ''
    })
    // @ts-ignore
    const [params, setParams]: QueryParams = useState({
        page: '1',
        perPage: '15',
        relations: 'city,state,tipo',
        whereBig: '',
    });
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [loadingSearch, setLoadingSearch] = useState(true);
    const [properties, setProperties] = useState([]);
    const [stateOptions, setStateOptions]: any = useState([])
    const [cityOptions, setCityOptions]: any = useState([]);
    const [typePropertiesOptions, setTypePropertiesOptions]: any = useState([])
    const [loadingDataCity, setLoadingDataCity] = useState(false);

    const [loadImoveis, setLoadImoveis] = useState(true);

    const [totalPage, setTotalPage] = useState();
    const[pageTo, setPageTo] = useState();

    const getDatas = async () => {
        const [statData, typePropertyData] = await Promise.all([
            statesApi.listAll(),
            typePropertyApi.listAll(),

        ]);
        if (!statData.isError){
            setStateOptions(statData.data.map((dt:any) => {return {value: dt.id, label: dt.description, code: dt.uf}}))
        }
        if (!typePropertyData.isError){
            const opt = typePropertyData.data.map((dt:any) => {return {value: dt.id, label: dt.descricao}});
            opt.unshift({value: '', label: 'Todos'})
            setTypePropertiesOptions(opt)
        }

        //setLoading(false)
    }

    const getProperties = async (page?: number) =>{

        if(!page){
            setLoading(true)
        }
        let whereBig = '';
        if (stateSearch.tipo_id){
            whereBig += 'where=tipo_id,=,'+stateSearch.tipo_id
        }
        if (stateSearch.state_id){
            if (whereBig.length){
                whereBig += '&where=state_id,=,'+stateSearch.state_id
            }else{
                whereBig += 'where=state_id,=,'+stateSearch.state_id
            }
        }
        if (stateSearch.city_id){
            if (whereBig.length){
                whereBig += '&where=city_id,=,'+stateSearch.city_id
            }else{
                whereBig += 'where=city_id,=,'+stateSearch.city_id
            }
        }

        const newParams = {...params};
        if (page){
            newParams.page = page;
        }else if(whereBig.length){
            newParams.page = 1
        }
        newParams.whereBig = whereBig;
        setParams(newParams);
        const {data, isError} = await propertyApi.getPropertiesHome(newParams);
        if (!isError){
            if(!page){
                setTotalPage(data.total)
                setPageTo(data.to)
                setProperties(data.data)
            }else{
                let countries = [].concat(properties, data.data);
                setTotalPage(data.total)
                setPageTo(data.to)
                setProperties(countries)
            }

        }
        setLoading(false)
        setLoadImoveis(false)

    }

    useEffect(() => {
        getDatas();
        getProperties();
    }, [])

    const getCity = async (idState: number, searchCep?: string) => {
        setLoadingDataCity(true)
        const {data, isError} = await cityApi.getCity(idState);
        if (!isError){
            const dataSelect = data.map((dt:any) => {return {value: dt.id, label: dt.description}});
            setCityOptions(dataSelect)
        }
        setLoadingDataCity(false)
    }

    const onSelectState = (value: any) => {
        const val = value ? value.value : '';
        setStateSearch({...stateSearch, ['state_id']: val});
        if (value){
            getCity(val)
        }
    }

    const handleChange = (value: any, input: string) => {
        setStateSearch({...stateSearch, [input]: value});
    };

    /*const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };*/

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            partialVisibilityGutter: 40, // this is optional if you are not using partialVisible props
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            partialVisibilityGutter: 30, // this is optional if you are not using partialVisible props
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 30, // this is optional if you are not using partialVisible props
        },
    };

    const loadNewProperties = async () => {
        setLoadImoveis(true);
        getProperties(parseInt(params.page)+1)
    }


    return(
        <PageContainer list>
            {
                loading ?
                    <div className={'w-full h-[calc(90vh_-_80px)]'}>
                        <span className="flex items-center justify-center w-full h-full h-7">
                            <svg className="animate-spin -ml-1 mr-3 h-[45px] w-[45px] text-[#003641]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#003641"  strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                    </div>
                    :
                    <div className={'flex flex-col items-center justify-center gap-4 md:mb-[4rem]'}>
                        <div className="flex flex-col md:flex-row items-center gap-2">
                            <div className="grid grid-cols-12 gap-5 content-center">
                                <InputSelect
                                    disabled={!properties.length}
                                    isClearable
                                    key={(Math.random() + 1).toString(36).substring(7)}
                                    selected={stateSearch.state_id}
                                    label={'Estado'}
                                    className={'md:col-span-4 xs:col-span-12'}
                                    options={stateOptions}
                                    onChangeSelect={(e: any) => onSelectState(e)}
                                    placeholder={'Estado'}
                                />
                                <InputSelect
                                    disabled={!properties.length}
                                    isClearable
                                    loading={loadingDataCity}
                                    key={(Math.random() + 1).toString(36).substring(7)}
                                    selected={stateSearch.city_id}
                                    label={'Cidade'}
                                    className={'md:col-span-4 xs:col-span-12'}
                                    options={cityOptions}
                                    onChangeSelect={(e: any) => handleChange(e ? e.value : '', 'city_id')}
                                    placeholder={'Cidade'}
                                />
                                <InputSelect
                                    disabled={!properties.length}
                                    key={(Math.random() + 1).toString(36).substring(7)}
                                    selected={stateSearch.tipo_id}
                                    label={'Tipo do imóvel'}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    options={typePropertiesOptions}
                                    onChangeSelect={(e: any) => handleChange(e.value, 'tipo_id')}
                                    placeholder={'Tipo de imóvel'}
                                />
                                <div className={'flex items-end'}>
                                    <button onClick={() => getProperties()} className="w-[50px] h-[50px]">
                                        <FaSearch />
                                    </button>
                                </div>

                            </div>
                        </div>
                        {
                            properties.length ?
                                <>

                                    <div className="grid md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-4 mb-[75px]">
                                        {
                                            properties.map((property: any) => {
                                                return (
                                                    <div className="flex flex-col max-w-sm rounded overflow-hidden shadow-2xl border p-2">
                                                        <Carousel
                                                            additionalTransfrom={0}
                                                            arrows
                                                            autoPlaySpeed={3000}
                                                            autoPlay
                                                            centerMode={false}
                                                            className=""
                                                            containerClass="container-with-dots"
                                                            dotListClass="z-10"
                                                            draggable
                                                            focusOnSelect={false}
                                                            infinite={property.images.length > 1}
                                                            keyBoardControl
                                                            minimumTouchDrag={80}
                                                            renderButtonGroupOutside={false}
                                                            renderDotsOutside={false}
                                                            responsive={responsive}
                                                            itemClass={'p-3'}
                                                            showDots={property.images.length > 1}
                                                        >
                                                            {
                                                                property.images.map((image: any) => {
                                                                    return (
                                                                        <div
                                                                            className={'w-full flex p-1 gap-1 justify-center items-center '}>
                                                                            <img
                                                                                className={'w-[350px] h-[250px]'}
                                                                                src={image.image_path}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </Carousel>
                                                        <div className="p-1 ">
                                                            <a href={'#'}>
                                                                <h5 className="mb-2 text-[18px] font-bold tracking-tight text-gray-900  w-full flex flex-col items-center">
                                                                    <div>Imóvel {property.tipo.descricao} </div>

                                                                    <div>{property.city.description} - {property.state.description}</div>
                                                                </h5>
                                                            </a>
                                                            <p className="mb-3 font-normal text-gray-700 flex flex-col items-center">
                                                                <div>{property.bairro}</div>
                                                                <div className={'flex w-full items-center justify-center gap-1'}>
                                                                    <BiArea />
                                                                    {
                                                                        property.area_terreno ? <div>{property.area_terreno} <span className={'text-sm'}>m²</span></div> : '-'
                                                                    }

                                                                </div>
                                                                <div className={'flex w-full items-center justify-center gap-1'} >
                                                                    <BsHouseCheckFill />
                                                                    {
                                                                        property.area_construida ? <div>{property.area_construida} <span className={'text-sm'}>m²</span></div> : '-'
                                                                    }

                                                                </div>
                                                            </p>

                                                        </div>
                                                        <div className={'flex justify-between items-center gap-3'}>
                                                            <div className={'px-3 py-2 text-[25px] font-bold text-[#003641]'}>
                                                                {Str.currencyMask(property.valor)}
                                                            </div>
                                                            <a href={'view/imovel/'+property.id} className="inline-flex h-[45px] items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#003641] rounded-lg hover:bg-opacity-80   ">
                                                                Ver imóvel
                                                                <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                                                                     aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                                     fill="none" viewBox="0 0 14 10">
                                                                    <path stroke="currentColor" stroke-linecap="round"
                                                                          stroke-linejoin="round" stroke-width="2"
                                                                          d="M1 5h12m0 0L9 1m4 4L9 9"/>
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }


                                    </div>
                                    <div className={'w-full flex justify-center mt-3 mb-3'}>
                                        {
                                            pageTo ?
                                                totalPage != pageTo ?
                                                    <button
                                                        onClick={() => loadNewProperties()}
                                                        className={'border w-[50px] h-[50px] border-border border-2 items-center flex justify-center rounded-full'}>
                                                        {
                                                            loadImoveis ?
                                                                <span className="items-center flex justify-center h-7">
                                                                        <svg className="animate-spin  h-[20px] w-[20px] text-border" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                        </svg>
                                                                    </span>
                                                                :
                                                                <FaArrowDown/>
                                                        }
                                                    </button>
                                                    :
                                                    ''
                                                :
                                                ''
                                        }

                                    </div>
                                </>


                                /*<div className={'flex flex-col md:w-[700px] gap-3 mb-[20px]'}>

                                    {
                                        properties.map((property: any) => {
                                            return(
                                                <div className={'rounded-xl  w-full bg-gray-50 p-5 shadow-md'}>
                                                    <div className={'flex justify-between  mb-2 '}>
                                                        <div className={'font-semibold text-[16px]'}>
                                                            {property.state.description} - {property.city.description} - {property.tipo.descricao}
                                                        </div>
                                                        <div>
                                                            <button onClick={() => navigate('view/imovel/'+property.id)} className={'bg-blue-500 hover:bg-blue-700 text-white font-semibold py-1 px-3 rounded'}>Ver imóvel</button>
                                                        </div>

                                                    </div>
                                                    <div className={''}>
                                                        {/!*<Carousel
                                                            responsive={responsive}
                                                            infinite={property.images.length > 1}
                                                            autoPlay
                                                            transitionDuration={6000}
                                                            showDots={property.images.length > 1}
                                                        >*!/}
                                                        <Carousel
                                                            additionalTransfrom={0}
                                                            arrows
                                                            autoPlaySpeed={3000}
                                                            autoPlay
                                                            centerMode={false}
                                                            className=""
                                                            containerClass="container-with-dots"
                                                            dotListClass=""
                                                            draggable
                                                            focusOnSelect={false}
                                                            infinite={property.images.length > 1}
                                                            keyBoardControl
                                                            minimumTouchDrag={80}
                                                            renderButtonGroupOutside={false}
                                                            renderDotsOutside={false}
                                                            responsive={responsive}
                                                            itemClass={'p-3'}
                                                            showDots={property.images.length > 1}
                                                        >
                                                            {
                                                                property.images.map((image: any) => {
                                                                    return(
                                                                        <div className={'w-full flex p-1 gap-1 justify-center items-center '}>
                                                                            <img
                                                                                className={'h-[350px] '}
                                                                                src={image.image_path}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </Carousel>
                                                    </div>
                                                    {
                                                        property.descricao ?
                                                            <div className={'text-[16px] mt-4 font-semibold'}>
                                                                {property.descricao}
                                                            </div>
                                                            :
                                                            ''
                                                    }

                                                    <div className={'text-[16px] mt-4 font-semibold'}>
                                                        Endereço: {property.endereco}
                                                        {property.numero ? ', Numero: '+property.numero : ''}
                                                        {property.quadra ? ', Qd: '+property.quadra : ''}
                                                        {property.lote ? ', Lt: '+property.lote : ''}
                                                    </div>
                                                    <div className={'text-[24px] font-bold mt-4'}>
                                                        {Str.currencyMask(property.valor)}
                                                    </div>
                                                    <div className={'flex w-full justify-center gap-4 font-semibold'}>
                                                        {
                                                            property.area_terreno ?
                                                                <div className={'flex flex-col items-center'}>
                                                                    <div>Terreno</div>
                                                                    <div> {property.area_terreno} <span className={'text-sm'}>m²</span></div>
                                                                </div>
                                                                :
                                                                ''
                                                        }
                                                        {
                                                            property.area_construida ?
                                                                <div className={'flex flex-col items-center'}>
                                                                    <div>Área contruida</div>
                                                                    <div> {property.area_construida} <span className={'text-sm'}>m²</span></div>
                                                                </div>
                                                                :
                                                                ''
                                                        }


                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                    <div className={'w-full flex justify-center mt-3 mb-3'}>
                                        {
                                            pageTo ?
                                                totalPage != pageTo ?
                                                    <button
                                                        onClick={() => loadNewProperties()}
                                                        className={'border w-[50px] h-[50px] border-border border-2 items-center flex justify-center rounded-full'}>
                                                        {
                                                            loadImoveis ?
                                                                <span className="items-center flex justify-center h-7">
                                                                        <svg className="animate-spin  h-[20px] w-[20px] text-border" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                        </svg>
                                                                    </span>
                                                                :
                                                                <FaArrowDown/>
                                                        }
                                                    </button>
                                                    :
                                                    ''
                                                :
                                                ''
                                        }

                                    </div>

                                </div>*/
                                :
                                <div className={'flex flex-col md:flex-row items-center'}>

                                    <div className="bg-green-300 border-l-4 text-green-700 border-green-700 p-4 md:w-[900px]" role="alert">
                                        Nenhum imóvel cadastrado
                                    </div>
                                </div>

                        }

                    </div>
            }
        </PageContainer>
    )
}